import React from "react";
import { List, Divider, Button, Input, message } from 'antd';
import dayjs from "dayjs";

export default ({ remark, orderId, shopId, onChange, prefix, orderData = {} }) => { 
    const remarks = remark?.split('$$') || [];

    const submit = () => {
        let remark = document.getElementById('remark-input').value;
        if (!remark) {
            return;
        }else if(prefix) {
            remark = `#${prefix}# ${remark}`;
        }
        const newRemark = `${remark} ${dayjs().format('MM-DD HH:mm')} @${window.__baseInfo.username}$$${remarks.join('$$')}`;
        
        updateRemark(newRemark).then(() => {
            document.getElementById('remark-input').value = '';
            onChange?.(newRemark);
        }).catch(() => {
            onChange?.('');
            message.error('提交失败');
        });
    }

    const updateRemark = async (remark) => {
        if (!remark || !orderId || !shopId) {
            return;
        }

        const response = await fetch(`/api/order/update?orderId=${orderId}&shopId=${shopId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sellerRemark: remark,
                ...orderData,
            })
        });
        const result = await response.json();

        if(result?.success) {
            message.success('提交成功');
        }else{
            message.error(result.data);
        }
    }

    return <div> 
        <List
            style={{ maxHeight: 600, margin: '0 0 10px 0', overflow: 'auto' }}
            header={null}
            footer={null}
            size="small"
            bordered
            dataSource={[...remarks].reverse()}
            renderItem={(item) => (
                <List.Item>
                    {item}
                </List.Item>
            )}
        />
        <Input id="remark-input" placeholder="请输入新的备注" count={{max: 30, show: true}} />
        <Button type="primary" style={{margin: '10px 0 0 auto'}} onClick={submit}>提交</Button>
    </div>
}